import { newE2EPage } from "@stencil/core/testing";

describe("uic-flyout", () => {
    it("should render and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-flyout>
                <div slot="content">
                    Content
                </div>
                <uic-button
                    slot="footer"
                    variant="footer"
                >
                    Close
                </uic-button>
            </uic-flyout>`);
        await page.waitForChanges();
        const flyout = await page.find("uic-flyout.hydrated");
        await page.waitForChanges();
        expect(flyout).toMatchSnapshot();
    });
});
